<template>
  <v-card>
    <v-card-text
      class="white--text px-6"
      v-bind:style="{
        backgroundColor: getColor($vuetify.theme.themes.light.accent, 0.2)
      }"
    >
      <v-card-title class="px-0 pt-0">Check your progress</v-card-title>
      <v-text-field
        outlined
        background-color="white"
        :value="`${users.length - 1} invitations accepted`"
        readonly
        hide-details
        dense
        color="secondary"
        class="embedded-btn"
      >
        <template v-slot:append="">
          <v-btn
            color="secondary"
            @click="$emit('refresh')"
            class="rounded-l-0"
          >
            refresh
          </v-btn>
        </template>
      </v-text-field>
      <div class="mt-2 font-weight-light primary--text text-center">
        Minimum 3 required to move forward
      </div>
    </v-card-text>
    <v-card-title class="px-6">
      FAQs
      <v-spacer> </v-spacer>
      <span class="subtitle-1 font-weight-light mr-1">Need help?</span>
      <a class="subtitle-1 font-weight-light info--text" @click="showBeacon">
        Contact us
      </a>
    </v-card-title>
    <v-card-text class="subtitle-1 px-0 pb-4 pt-0">
      <v-expansion-panels flat :value="questionIndex">
        <v-expansion-panel>
          <v-expansion-panel-header
            class="subtitle-1 font-weight-bold secondary--text"
          >
            What will my invited people be asked to do?
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <ul>
              <li>Provide their name & email</li>
              <li>
                Answer the
                <span class="text-decoration-underline">eNPS</span> Culture
                Tracking question
                <a
                  href="#"
                  :data-beacon-article-modal="$helpscout.ENPS"
                  class="info--text subtitle-2"
                >
                  What's the eNPS question?
                </a>
              </li>
              <li>
                Provide feedback about working at {{ profile.companyName }}
              </li>
            </ul>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header
            class="subtitle-1 font-weight-bold secondary--text"
          >
            What will I see after 3 people have accepted my invitation?
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <ul>
              <li>Who has accepted your invitation</li>
              <li>
                How people feel about working for {{ profile.companyName }}
              </li>
              <li>Options to ask more Culture Tracking questions</li>
            </ul>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header
            class="subtitle-1 font-weight-bold secondary--text"
          >
            Can I add more people later?
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            Yes, after this initial invite setup you may add additional people
            individually, or via a bulk import.
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header
            class="subtitle-1 font-weight-bold secondary--text"
          >
            Can you help me onboard my team?
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            Yes, please reach out to us using the Contact Us link above.
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "DashboardShareInstructionsFaqCard",
  data: () => ({ questionIndex: 0 }),
  computed: {
    ...mapGetters({ profile: "profile/profile", users: "user/users" })
  },
  methods: {
    showBeacon() {
      window.Beacon("open");
    }
  }
};
</script>
